"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rioAlertTypes = exports.rioAlertSizes = exports.closeIconSizes = void 0;
exports.closeIconSizes = [12, 16, 20, 24];
exports.rioAlertSizes = [10, 12, 16, 20, 24];
exports.rioAlertTypes = ['error', 'information', 'success', 'warning'];
